(() => {
  const initAccordion = (section) => {
    if (section.dataset.accordionReady === 'true') return;
    const panels = [...section.querySelectorAll('[data-bba-routine-panel]')];
    if (!panels.length) return;

    section.dataset.accordionReady = 'true';

    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const activate = (panel, focus = false, allowCollapse = false) => {
      const collapse = allowCollapse && mobileQuery.matches && panel.classList.contains('is-active');
      panels.forEach((item) => {
        const active = !collapse && item === panel;
        item.classList.toggle('is-active', active);
        item.querySelector('.bba-routine__trigger')?.setAttribute('aria-expanded', String(active));
      });
      if (focus) panel.querySelector('.bba-routine__trigger')?.focus();
    };

    panels.forEach((panel, index) => {
      const trigger = panel.querySelector('.bba-routine__trigger');
      trigger?.addEventListener('click', () => activate(panel, false, true));
      trigger?.addEventListener('focus', () => {
        if (!mobileQuery.matches) activate(panel);
      });
      trigger?.addEventListener('keydown', (event) => {
        const previousKey = mobileQuery.matches ? 'ArrowUp' : 'ArrowLeft';
        const nextKey = mobileQuery.matches ? 'ArrowDown' : 'ArrowRight';
        if (event.key !== previousKey && event.key !== nextKey) return;
        event.preventDefault();
        const direction = event.key === nextKey ? 1 : -1;
        activate(panels[(index + direction + panels.length) % panels.length], true);
      });
    });

    if (mobileQuery.matches) {
      panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.querySelector('.bba-routine__trigger')?.setAttribute('aria-expanded', 'false');
      });
    }

    section.addEventListener('shopify:block:select', (event) => {
      const selected = panels.find((panel) => panel.dataset.blockId === event.detail.blockId);
      if (selected) activate(selected);
    });
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-bba-collection-accordion]')) initAccordion(root);
    root.querySelectorAll('[data-bba-collection-accordion]').forEach(initAccordion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
